import React from 'react';
import { motion } from 'framer-motion';
import { painPoints } from '../data/painPoints';
export function PainPoints() {
  return <section aria-label="Points de douleur" className="border-y border-grape/10 bg-white/70" data-id="element-105" data-mp="2lmsqcmz6p8ku">
      <div className="mx-auto max-w-4xl px-5 pb-12 pt-10" style={{
      paddingBottom: '8px',
      paddingTop: "11px"
    }} data-id="element-106" data-mp="26xmpkukp7aau">
        <h2 className="text-center font-display text-[25px] font-black text-plum sm:text-4xl" data-id="element-107" data-mp="2bvocjql8vtrl">
          Est-ce que cela vous ressemble ?
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-center text-base leading-relaxed text-plum/70" data-id="element-108" data-mp="21zur1hpjspxo">
          Vous aimez le droit, mais chaque fois que vous vous asseyez à votre bureau pour rédiger, vous vous perdez
          dans le jargon technique, les failles juridiques et la peur de la page blanche ou d'une erreur de l'IA.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg font-bold text-grape" data-id="element-109" data-mp="3ie4du7e566me">
          Ce n'est pas un manque de compétence. C'est un manque de <span className="text-blush" data-id="element-110" data-mp="1z0f0ax1kva7f">Framework Stratégique</span>.
        </p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-111" data-mp="1yyc23pq9uarm">
          {painPoints.map((p, i) => <motion.div key={p.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-xl border border-grape/15 bg-cream p-5" style={{
          paddingTop: "10px",
          paddingBottom: "10px"
        }} data-id="element-112" data-mp="1tzhk2q04oq8k" data-mpi={i}>
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-lilac-soft text-sm" aria-hidden="true" data-id="element-113" data-mp="1p28x8c41by0z">
                {p.emoji}
              </span>
              <div data-id="element-114" data-mp="30he4ltf42kqx">
                <h3 className="text-sm font-bold text-plum" data-id="element-115" data-mp="30guyrb2qjmt9">{p.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-plum/65" data-id="element-116" data-mp="2vikyim25lw0s">{p.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-117" data-mp="1t4ddyujicu4m">
          <p className="font-display text-2xl font-bold text-plum sm:text-3xl" data-id="element-118" data-mp="1t7hnm7fqsi2o">
            ✨ Si vous avez répondu OUI, SIGMA SMART™ a la solution.
          </p>
        </div>
      </div>
    </section>;
}